import React, { useContext, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import { BsFillPencilFill } from 'react-icons/bs';
import { ModalTambahAkunPegawai, ModalUbahAkunPegawai } from '../../../../Modal';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeDark,
    colorSchemeLightCold,
    DateFilterModule,
    themeQuartz
} from 'ag-grid-community';
import { ThemeContext } from '../../../../../auth';
import { useMediaQuery } from 'react-responsive';


function TabsAkunDark({
    listAkun,
    listDivisi,
    listRole,
    retrieveDivisi,
    retrieveRole,
    retrieveAkun,
    accessToken,
}) {

    const isMobile = useMediaQuery({ maxWidth: 736 });

    const { theme } = useContext(ThemeContext);

    const [showTambahPegawai, setShowTambahPegawai] = useState(false);
    const handleShowTambahAkun = () => {
        setShowTambahPegawai(true);
        retrieveDivisi();
        retrieveRole();
    };

    const [rowSelected, setRowSelected] = useState();
    const [showEditPegawai, setShowEditPegawai] = useState(false);
    const handleShowEditAkun = (row) => {
        setShowEditPegawai(true);
        setRowSelected(row);
        retrieveDivisi();
        retrieveRole();
    };

    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        const dataTableFilter = listAkun?.map(({ ...rest }) => rest);

        setDataTable(
            dataTableFilter.map((data) => {
                return {
                    ...data,
                    fullName: data?.firstName + ' ' + data?.lastName,
                    division: data?.role.group.groupName,
                    roles: data?.role.roleName,
                };
            })
        );
    }, [listAkun]);

    ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);
    const themecolorSchemeDark = themeQuartz.withPart(colorSchemeDark);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (dataTable && dataTable.length > 0) {
            setRowData(dataTable);
        }
    }, [dataTable]);

    // console.log(rowData)

    const colDefs = [
        {
            field: "fullName",
            headerName: "Nama",
            sortable: true,
            sort: 'asc',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.fullName}
                    </div>
                );
            },
        },
        {
            field: "username",
            headerName: "Username",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.username}
                    </div>
                );
            },
        },
        {
            field: "email",
            headerName: "Email",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.email}
                    </div>
                );
            },
        },
        {
            field: "division",
            headerName: "Divisi",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.division}
                    </div>
                );
            },
        },
        {
            field: "roles",
            headerName: "Role",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.roles}
                    </div>
                );
            },
        },
        {
            field: "status",
            headerName: "Status",
            sortable: true,
            cellRenderer: (row) => {
                const isActive = row?.data?.isActive;
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "left",
                            color: isActive ? "green" : "red",
                            fontSize: "16px",
                        }}
                    >
                        {isActive ? "Aktif" : "Tidak Aktif"}
                    </div>
                );
            },
        },
        {
            field: 'ubah',
            headerName: 'Ubah',
            width: 100,
            pinned: 'right',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleShowEditAkun(row.data)}
                    >
                        <Button
                            variant='btn'
                            onClick={() => handleShowEditAkun(row.data)}
                        >
                            &nbsp;<BsFillPencilFill size={20} color={theme == 'light' ? '#12B3ED' : '#006CB8'} />&nbsp;
                        </Button>
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const [tableHeight, setTableHeight] = useState(window.innerHeight - 200); // Initial height

    useEffect(() => {
        const updateHeight = () => {
            setTableHeight(window.innerHeight - 200); // Adjust as needed
        };

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div className='mt-3' style={{ height: tableHeight }}>
            <Button
                id={theme === 'light' ? 'actionButtonTabelDark' : 'actionButtonTabelLight'}
                variant='btn'
                style={{ color: theme === 'light' ? '#222' : 'white', fontSize: '14px' }}
                onClick={handleShowTambahAkun}
            >
                Tambah
            </Button>

            <AgGridReact
                theme={theme === "light" ? themecolorSchemeDark : themeLightCold}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                pagination={isMobile ? false : true}
                rowHeight={30}
            />
            <ModalTambahAkunPegawai
                showTambahPegawai={showTambahPegawai}
                setShowTambahPegawai={setShowTambahPegawai}
                accessToken={accessToken}
                retrieveAkun={retrieveAkun}
                listDivisi={listDivisi}
            />
            <ModalUbahAkunPegawai
                rowSelected={rowSelected}
                showEditPegawai={showEditPegawai}
                setShowEditPegawai={setShowEditPegawai}
                retrieveAkun={retrieveAkun}
                accessToken={accessToken}
                listRole={listRole}
                listDivisi={listDivisi}
            />
        </div>
    )
}

export default TabsAkunDark
